<template>
    <div class="wang-editor" style="border: 1px solid #ccc; margin-bottom: 15px;">
        <Toolbar style="border-bottom: 1px solid #ccc" :editor="editor" :defaultConfig="toolbarConfig" />
        <Editor style="height: 400px; overflow-y: hidden;" :value="mainBody" :defaultConfig="editorConfig"
            @onCreated="onCreated" @onChange="onChange" />
    </div>
</template>
<script>
import { Boot } from '@wangeditor/editor'
import attachmentModule from '@wangeditor/plugin-upload-attachment'

// 注册。要在创建编辑器之前注册，且只能注册一次，不可重复注册。
Boot.registerModule(attachmentModule)

import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import host from '@/api/index';
export default {
    name: 'wangEditor',
    components: {
        Editor,
        Toolbar,
    },
    props: {
        mainBody: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            editor: null,
            toolbarConfig: {
                excludeKeys: ["insertImage", "uploadVideo", "fontFamily"],
                // 插入哪些菜单
                insertKeys: {
                    index: 0, // 自定义插入的位置
                    keys: ['uploadAttachment'], // “上传附件”菜单
                },
            },
            editorConfig: {
                placeholder: '',
                // 在编辑器中，点击选中“附件”节点时，要弹出的菜单
                hoverbarKeys: {
                    attachment: {
                        menuKeys: ['downloadAttachment'], // “下载附件”菜单
                    },
                },
                MENU_CONF: {
                    uploadImage: {
                        // 图片文件上传接口地址
                        server: host.uploadImgUrl,
                        timeout: 5 * 1000, // 5s
                        // fieldName 要与接口规定的Form Data文件字段名一致
                        fieldName: 'file',
                        headers: {
                            'bg-token': localStorage.getItem('token')
                        },
                        allowedFileTypes: ['image/png', 'image/jpeg'], // 允许的文件类型
                        maxFileSize: 10 * 1024 * 1024, // 10M
                        // 若接口返回的数据结构与官方规定的不一致, 则需要 customInsert 方法将返回的路径传给编辑器
                        customInsert(res, insertFn) {
                            const url = res.data.url
                            insertFn(url)
                        },
                        onSuccess: (file, res) => {
                            console.log('图片上传成功', file, res);
                        },
                        onError: (file, err) => {
                            console.error('图片上传失败', file, err);
                        },
                    },
                    fontSizeDefault: '20', // 设置默认字号为 20
                    fontSize: {
                        fontSizeList: [
                            '12',
                            '13',
                            '14',
                            '15',
                            '16',
                            '18',
                            '20',
                            '22',
                            '24',
                            '26',
                            '28',
                            '30',
                            '32',
                            '40',
                        ],
                    },
                    // “上传附件”菜单的配置
                    uploadAttachment: {
                        server: host.uploadImgUrl, // 服务端地址
                        timeout: 5 * 1000, // 5s

                        fieldName: 'file',
                        headers: {
                            'bg-token': localStorage.getItem('token')
                        },
                        maxFileSize: 100 * 1024 * 1024, // 100M
                        onBeforeUpload(file) {
                            console.log('onBeforeUpload', file)
                            return file // 上传 file 文件
                            // return false // 会阻止上传
                        },
                        // onProgress(progress) {
                        //     console.log('onProgress', progress)
                        // },
                        // onSuccess(file, res) {
                        //     console.log('onSuccess', file, res)
                        // },
                        // onFailed(file, res) {
                        //     alert(res.message)
                        //     console.log('onFailed', file, res)
                        // },
                        // onError(file, err, res) {
                        //     alert(err.message)
                        //     console.error('onError', file, err, res)
                        // },

                        // 上传成功后，用户自定义插入文件
                        customInsert(res, file, insertFn) {
                            console.log('customInsert', res)
                            const { url } = res.data || {}
                            if (!url) throw new Error(`url is empty`)

                            // 插入附件到编辑器
                            insertFn(`${file.name}`, url)
                        },

                        // // 用户自定义上传
                        // customUpload(file: File, insertFn: Function) {
                        //   console.log('customUpload', file)

                        //   return new Promise(resolve => {
                        //     // 插入一个文件，模拟异步
                        //     setTimeout(() => {
                        //       const src = `https://www.w3school.com.cn/i/movie.ogg`
                        //       insertFn(`customUpload-${file.name}`, src)
                        //       resolve('ok')
                        //     }, 500)
                        //   })
                        // },

                        // // 自定义选择
                        // customBrowseAndUpload(insertFn: Function) {
                        //   alert('自定义选择文件，如弹出图床')
                        //   // 自己上传文件
                        //   // 上传之后用 insertFn(fileName, link) 插入到编辑器
                        // },

                        // 插入到编辑器后的回调
                        onInsertedAttachment(elem) {
                            console.log('inserted attachment', elem)
                        },
                    },
                }
            },
        }
    },
    methods: {
        onCreated(editor) {
            console.log('editor created!', editor.getConfig());
            this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
            this.editor.setHtml(this.mainBody)
        },
        onChange(editor) {
            this.$emit('onChange', editor.getHtml());
        }
    }
}
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<style lang="scss" scoped>
.w-e-full-screen-container {
    z-index: 9999;
}
/deep/.w-e-text-container [data-slate-editor] p{
    // margin: 0 !important;
    // letter-spacing: 2px;
    font-size: 20px;
}
</style>